// Pure predicates for pricing tiers Step 1 (spec/pricing-tiers.html). Pulled
// out of Dashboard.js so they're testable in isolation -- see
// scripts/test-pricing-gates.mjs, which pins every edge case and runs in the
// pre-commit hook. organizations.plan is null for every org that pre-dates
// the tier system, so every one of these is a deliberate no-op until an org
// actually has a plan set.
//
// Mirrored (not imported -- no shared package) in the Chrome extension's
// config.js (needsSeatUpgradeGate) and the mobile PWA's src/pricingGates.js
// (shouldGateBillableSeatUpgrade). Keep all three in sync by hand.

export function shouldGateBillableSeatUpgrade({ orgPlan, seatClassification, isBillable, client }) {
  return !!orgPlan && seatClassification === 'administrative' && isBillable !== false && !!client && !client.is_internal;
}

export function isFreeClientCapReached(orgPlan, clients, cap = 5) {
  return orgPlan === 'free' && (clients || []).filter(c => c.is_active).length >= cap;
}

export function canSubmitContractorInvoice(orgPlan) {
  return orgPlan !== 'free';
}
